module.exports = __webpack_public_path__ + "image-51e0acaa874e.png";